import React, { Component } from 'react'
import { connect } from 'react-redux'
import Public from './Public'
import Admin from './Admin'
import Logout from './Logout'
import { withRouter, Route, Switch } from 'react-router-dom'

class App extends Component {

    render() {
        return (
            <Switch>
                <Route path="/logout" component={Logout} />
                <Route path="/admin" component={Admin} />
                <Route path="/" component={Public} />
            </Switch>
        )
    }
}

const mapStateToProps = (state) => {
    const nextProps = Object.assign({}, state.auth)
    return nextProps
}

const mapDispatchToProps = (dispatch, props) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))



// WEBPACK FOOTER //
// ./src/containers/App.js